export class TextUtils {
    public static isAlphaNumeric(text: string): boolean {
        if (!text) return false;
        const expression = /^[A-Za-z0-9]+$/;
        return text.match(expression) !== null;
    }
}
